// extracted by mini-css-extract-plugin
export default {"mapSelect":"Lobby_mapSelect__SpWN-"};